import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/qrCode";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import EventSaveTemplateWidget from "../../../../components/Apps/QRCode/Template/EventSaveTemplateWidget";
import GetDiscountTemplateWidget from "../../../../components/Apps/QRCode/Template/GetDiscountTemplateWidget";
import SaveMyContactTemplateWidget from "../../../../components/Apps/QRCode/Template/SaveMyContactTemplateWidget";
import RateOnTripadvisorTemplateWidget from "../../../../components/Apps/QRCode/Template/RateOnTripadvisorTemplateWidget";
import ViewPdfTemplateWidget from "../../../../components/Apps/QRCode/Template/ViewPdfTemplateWidget";
import RateOnFacebookTemplateWidget from "../../../../components/Apps/QRCode/Template/RateOnFacebookTemplateWidget";

//Import Tabs
import GenerateTab from "../../../../components/Apps/QRCode/GenerateTab";
import InfoTab from "../../../../components/Apps/QRCode/InfoTab";
import FrameTab from "../../../../components/Apps/QRCode/FrameTab";
import StyleTab from "../../../../components/Apps/QRCode/StyleTab";

export default function CreateQRCode() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Generate");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Event_Save_Temp");
    const [selectedLayout, setSelectedLayout] = useState("event_save_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("event-save.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled QR Code");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [qrCodeTabData, setQRCodeTabData] = useState({
        is_website_frontend: "",  
        generate_type: "URL",     
        generate_url: "https://dashboard.upgadeify.com",  
        generate_location: "",   
        title: "",   
        call_to_action_text: "",   
        caption: "",   
        frame_type: "",   
        qr_code_size: 200,   
        title_color: "",     
        foreground_color: "",     
        background_color: "",     
        frame_color: "",     
        caption_color: "",     
        title_font_size: "20px",     
        call_to_action_font_size: "15px",     
        caption_font_size: "13px",     
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let call_to_action_text = "";
            let frame_type = "";
            let title_color = "";
            let foreground_color = "";
            let background_color = "";
            let frame_color = "";
            let caption_color = "";
        
            switch (activeTemplateSection) {
                case "Event_Save_Temp":
                    call_to_action_text = "SAVE THE DATE";
                    frame_type = "frame_4";
                    title_color = "#000";
                    foreground_color = "#7d23a3";
                    background_color = "#ffffff";
                    frame_color = "rgb(168, 100, 255)";
                    caption_color = "#000";
                    break;
                case "Get_Discount_Temp":
                    call_to_action_text = "Get Discount";
                    frame_type = "frame_3";
                    title_color = "#000";
                    foreground_color = "#fff";
                    background_color = "#000";
                    frame_color = "#e43b3b";
                    caption_color = "#000";
                    break;
                case "Save_My_Contact_Temp":
                    call_to_action_text = "Save my Contact";
                    frame_type = "frame_7";
                    title_color = "#000";
                    foreground_color = "rgb(37, 33, 33)";
                    background_color = "#fff";
                    frame_color = "rgb(37, 33, 33)";
                    caption_color = "#000";
                    break;
                case "Rate_On_Tripadvisor_Temp":
                    call_to_action_text = 'Review us on Tripadvisor';
                    frame_type = "frame_9";
                    title_color = "#fff";
                    foreground_color = "rgb(37, 33, 33)";
                    background_color = "#fff";
                    frame_color = "#34E0A1";
                    caption_color = "#fff";
                    break;
                case "View_Pdf_Temp":
                    call_to_action_text = "View PDF";
                    frame_type = "frame_6";
                    title_color = "#000";
                    foreground_color = "rgb(37, 33, 33)";
                    background_color = "#fff";
                    frame_color = "rgb(224, 92, 66)";
                    caption_color = "#000";
                    break;
                case "Rate_On_Facebook_Temp":
                    call_to_action_text = "Rate us on Facebook";
                    frame_type = "frame_9";
                    title_color = "#000";
                    foreground_color = "rgb(37, 33, 33)";
                    background_color = "#fff";
                    frame_color = "rgb(8, 102, 255)";
                    caption_color = "#000";
                    break;
                default:
                    call_to_action_text = "";
                    frame_type = "";
                    title_color = "";
                    foreground_color = "";
                    background_color = "";
                    frame_color = "";
                    caption_color = "";
            }
        
            // Update setQRCodeTabData state with the data
            setQRCodeTabData((prevData) => ({
                ...prevData,
                call_to_action_text: call_to_action_text,
                frame_type: frame_type,
                title_color: title_color,
                foreground_color: foreground_color,
                background_color: background_color,
                frame_color: frame_color,
                caption_color: caption_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateQRCodeTabData = (key, value) => {
        setQRCodeTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Generate", icon: "generate.png", label: "Generate" },
      { key: "Info", icon: "info.png", label: "Info" },
      { key: "Frame", icon: "frame.png", label: "Frame" },
      { key: "Style", icon: "style.png", label: "Style" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true); 
      try {
        // Collect data from refs
        const settingsArray = Object.entries(qrCodeTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "QR_Code",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/qr-code');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="QR Code" app_type="QR_Code" app_slug="qr-code"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Event_Save_Temp" data-layout_type="event_save_layout" data-template_image="event-save.png" checked={activeTemplateSection === "Event_Save_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/event-save.png`} alt="event-save" />
                                    </div> 
                                    <div className="content_sub">Event - Save the date</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Get_Discount_Temp" data-layout_type="get_discount_layout" data-template_image="get-discount.png" checked={activeTemplateSection === "Get_Discount_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/get-discount.png`} alt="get-discount" />
                                    </div> 
                                    <div className="content_sub">Get Discount</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Save_My_Contact_Temp" data-layout_type="save_my_contact_layout" data-template_image="save-my-contact.png" checked={activeTemplateSection === "Save_My_Contact_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/save-my-contact.png`} alt="save-my-contact" />
                                    </div> 
                                    <div className="content_sub">Save my Contact</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Rate_On_Tripadvisor_Temp" data-layout_type="review_on_tripadvisor_layout" data-template_image="review-on-tripadvisor.png" checked={activeTemplateSection === "Rate_On_Tripadvisor_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/review-on-tripadvisor.png`} alt="review-on-tripadvisor" />
                                    </div> 
                                    <div className="content_sub">Review us on Tripadvisor</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="View_Pdf_Temp" data-layout_type="view_pdf_layout" data-template_image="view-pdf.png" checked={activeTemplateSection === "View_Pdf_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/view-pdf.png`} alt="view-pdf" />
                                    </div> 
                                    <div className="content_sub">View PDF </div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Rate_On_Facebook_Temp" data-layout_type="rate_on_facebook_layout" data-template_image="rate-on-facebook.png" checked={activeTemplateSection === "Rate_On_Facebook_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/qr-code/templates/rate-on-facebook.png`} alt="rate-on-facebook" />
                                    </div> 
                                    <div className="content_sub">Rate us on Facebook</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/qr-code/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Generate" && (
                              <GenerateTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                            )}
                            {activeSection === "Info" && (
                              <InfoTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                            )}
                            {activeSection === "Frame" && (
                              <FrameTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateQRCodeTabData={updateQRCodeTabData} qrCodeTabData={qrCodeTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/qr-code"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/qr-code/qr-code.svg`} alt="qr-code"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/qr-code/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/qr-code" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">QR Code <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Event_Save_Temp" && (
                      <EventSaveTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Get_Discount_Temp" && (
                      <GetDiscountTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Save_My_Contact_Temp" && (
                      <SaveMyContactTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Rate_On_Tripadvisor_Temp" && (
                      <RateOnTripadvisorTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "View_Pdf_Temp" && (
                      <ViewPdfTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                    {activeTemplateSection === "Rate_On_Facebook_Temp" && (
                      <RateOnFacebookTemplateWidget qrCodeTabData={qrCodeTabData} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 